import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from "@angular/core";
import { Person } from "../../interfaces/person";
import { FormControl } from "@angular/forms";
import { Subscription } from "rxjs";
import { EmployeeSearchService } from "./employee-search.service";

@Component({
    selector: 'employee-search',
    templateUrl: './employee-search.component.html',
    styleUrls: ['./employee-search.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EmployeeSearchComponent {
    @Input() person?:Person|null = null;
    @Output() personChanged = new EventEmitter<Person|null>();
    formControl= new FormControl<Person|string|null>(null);
    sub: Subscription;
    constructor(public personSearchService: EmployeeSearchService) {
    }

    ngOnInit(){
      this.formControl.setValue(this.person ?? null);
      this.sub = this.formControl.valueChanges.subscribe((value)=>{
        if(typeof value === "string"){
          this.personSearchService.searchPeople(value);
        }else if( value !== null){
          this.personChanged.emit(value);
        }
      })
    }
    displayFn(person: Person|null) {
      return person?.name ?? '';
    }
    ngOnDestroy(){
      this.sub?.unsubscribe();
    }
}
